// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1xi2oahv{right:var(--ds-space-600,3pc)}\n._94n5oahv{bottom:var(--ds-space-600,3pc)}\n._k8m01rjc{transition-property:transform,opacity}\n._kqsw1n9t{position:fixed}", ""]);
// Exports
module.exports = exports;
